@@ -1,179 +1,204 @@
<!--
 * @Author: wzh
 * @LastEditTime: 2024-04-24 11:33:40
 * @Description: 账号安全 修改密码
-->
<template>
	<div>
		<!-- 头部标题 -->

		<Head :title="$t('home.account_set.password_btn')" v-if="isHead" />




		<div class="form">
			<a-form-model :model="form" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
				<a-form-model-item :label="$t('base.password.old')" prop="oldPassword">
					<a-input-password v-model="form.oldPassword" :maxLength="32"
						:placeholder="$t('base.password.old_placeholder')" />

					<a v-if="isForget" class="forget-pass" @click="handleForget">{{ $t("base.password.tip") }}</a>
				</a-form-model-item>

				<a-form-model-item :label="$t('base.password.new')" prop="password">

					<a-tooltip placement="topLeft">
						<template slot="title">
							<div v-html="passwordRules"></div>
						</template>
						<a-input-password autocomplete="new-password" v-model="form.password" :maxLength="32"
							:placeholder="$t('base.password.new_placeholder')" />
					</a-tooltip>

					<div style="display: none;">
						<a-tooltip>
							<template slot="title">
								<div v-html="passwordRules"></div>
							</template>
							<div class="mm-tips">
								<a-icon type="question-circle" theme="filled" /> {{
								$t("base.password.strength") }}: {{ strength }}
							</div>

						</a-tooltip>
					</div>
				</a-form-model-item>

				<a-form-model-item :label="$t('base.password.new_confirm')" prop="confirmPassword">
					<a-input-password autocomplete="new-password" v-model="form.confirmPassword" :maxLength="32"
						:placeholder="$t('base.password.new_confirm_placeholder')" />

				</a-form-model-item>
			</a-form-model>
		</div>

		<!-- 忘记密码弹窗 -->
		<Dialog :title="$t('login.forget_password')" ref="forgetPass" width="900px" class="none-footer"
			:noneFooter="true">

			<forget :safeSetInfo="safeSetInfo" @success="() => $refs.forgetPass.closeModal()" />
			<template slot="butList">
				<div></div>
			</template>


		</Dialog>
	</div>
</template>

<script>
	import Head from "./components/Head";
	import { Dialog } from "@/components/public/dialog/ant";
	import { forget } from "@/views/forget";
	import { PasswordStrength } from "@/mixins/password";

	export default {
		components: { Head, Dialog, forget },
		props: {
			safeSetInfo: { type: Object, default: () => { } },
			pswSetInfo: { type: Object, default: () => { } },
			isHead: { type: Boolean, default: true },
			isForget: { type: Boolean, default: true },
		},
		mixins: [PasswordStrength],
		data() {
			let validatePass = (rule, value, callback) => {
				if (value != "") {
					let reg1 = escape(value).includes("%u"); // 是否包含中文字符、汉字
					let reg2 = new RegExp(/\s+/g); // 是否包含空格
					if (reg1 || reg2.test(value)) {
						callback(new Error(this.$t("base.password.format_error")));
					}
					if (this.form.password2) {
						this.$refs.form.validateField("password2");
					}
					callback();
				}
			};
			let validatePass2 = (rule, value, callback) => {
				if (value != "") {
					if (value !== this.form.password) {
						callback(new Error(this.$t("base.password.again_error")));
					} else {
						callback();
					}
				}
			};









			return {
				labelCol: { span: 6 },
				wrapperCol: { span: 13 },
				form: {
					oldPassword: "",
					password: "",
					confirmPassword: "",
					passwordStrength: "",
				},
				rules: {
					oldPassword: [{ required: true, message: this.$t("base.password.old_placeholder") }],
					password: [{ required: true, message: this.$t("base.password.new_placeholder") }, { validator: validatePass }],
					confirmPassword: [{ required: true, message: this.$t("base.password.new_confirm_placeholder") }, { validator: validatePass2 }],
				},
			};
		},
		computed: {
			passwordRules() {
				let obj = { ...this.pswSetInfo };
				if (obj.mmcl == 1) {
					let html1 = `<div>
						${this.$t("base.password.length_tip")}
						
						${obj.zlrmmgzcd}
						${this.$t("base.punctuation.comma")}
						${this.$t("base.password.least_includes_tip")}
						${this.$t("base.punctuation.colon")}
						${obj.zlrmmgzsl}
					</div>`
					let html2 = `<div>
						${this.$t("base.password.length_tip")}
						
						${obj.zlzmmgzcd}
						${this.$t("base.punctuation.comma")}
						${this.$t("base.password.least_includes_tip")}
						${this.$t("base.punctuation.colon")}
						${obj.zlzmmgzsl}
						</div>`
					let html3 = `<div>
						${this.$t("base.password.length_tip")}
						
						${obj.zlqmmgzcd}
						${this.$t("base.punctuation.comma")}
						${this.$t("base.password.least_includes_tip")}
						${this.$t("base.punctuation.colon")}
						${obj.zlqmmgzsl}
						</div>`
					return { '1': html1, '2': html2, '3': html3 }[obj.bmz]
					// let html = this.$t("base.password.weak_password") + this.$t("base.punctuation.colon") + html1 + this.$t("base.password.medium_password") + this.$t("base.punctuation.colon") + html2 + this.$t("base.password.strong_password") + this.$t("base.punctuation.colon") + html3;
					// return html
				} else {
					let html1 = `
					<div>
						${this.$t("base.password.length_tip")}
						
						${obj.tjrmmgzcd}
						${this.$t("base.punctuation.comma")}
						${this.$t("base.password.must_includes_tip")}
						${this.formatterClass(obj.tjrmmgzbh)}
						<br/></div>`
					let html2 = `
					<div>
						${this.$t("base.password.length_tip")}
						
						${obj.tjzmmgzcd}
						${this.$t("base.punctuation.comma")}
						${this.$t("base.password.must_includes_tip")}
						${this.formatterClass(obj.tjzmmgzbh)}
						</div>`
					let html3 = `<div>
						${this.$t("base.password.length_tip")}
						
						${obj.tjqmmgzcd}
						${this.$t("base.punctuation.comma")}
						${this.$t("base.password.must_includes_tip")}
						${this.formatterClass(obj.tjqmmgzbh)}
						</div>`
					return { '1': html1, '2': html2, '3': html3 }[obj.bmz]
					// let html = this.$t("base.password.weak_password") + this.$t("base.punctuation.colon") + html1 + this.$t("base.password.medium_password") + this.$t("base.punctuation.colon") + html2 + this.$t("base.password.strong_password") + this.$t("base.punctuation.colon") + html3;
					// return html
				}
			}
		},
		methods: {
			// 忘记密码
			handleForget() {
				this.$refs.forgetPass.openModal();
			},
			// 种类返回汉字
			formatterClass(str) {
				let arr = (str || "").split(",");
				let list = [
					this.$t("base.password.capital"),
					this.$t("base.password.lowercase"),
					this.$t("base.password.number"),
					this.$t("base.password.character"),
				];
				let htmlArr = [];
				for (let i = 0; i < arr.length; i++) {
					htmlArr.push(list[arr[i] - 1]);
				}
				return htmlArr.join("、");
			},
		},
	};
</script>

<style lang="less" scoped>
	.valid-mask-img {
		width: 100px;
		height: 33px;
		margin-left: 5px;
	}

	.forget-pass {
		position: absolute;
		right: 0;
		transform: translate(calc(100% + 10px));
		color: var(--primary-color);
	}

















	.mm-tips {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translate(calc(100% + 10px), -50%);
		color: var(--primary-color);
		cursor: pointer;
	}
</style>